import React from "react";
import { useFieldContext } from "../../hooks/useAppForm";
import styles from "./Switch.module.css";

export type SwitchProps = {
  readOnly?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export function Switch({ readOnly, ...props }: SwitchProps) {
  return (
    <span className={styles.SwitchTrack}>
      <input
        {...props}
        className={styles.SwitchInput}
        data-read-only={readOnly || undefined}
        onChange={(e) => {
          if (readOnly) {
            e.preventDefault();
            return;
          }
          props.onChange?.(e);
        }}
        type="checkbox"
        value="on"
      />
    </span>
  );
}

export function SwitchField(props: SwitchProps) {
  const field = useFieldContext<boolean>();
  return (
    <Switch
      {...props}
      checked={field.state.value}
      form={field.form.formId}
      onBlur={field.handleBlur}
      onChange={(e) => field.handleChange(e.target.checked)}
    />
  );
}
